import { Image } from "react-grid-gallery";

export interface CustomImage extends Image {
  original: string;
}


export const images: CustomImage[] = [
  {
    src: "/assets/img/about/_1160131.jpg",
    original: "/assets/img/about/_1160131.jpg",
    width: 253,
    height: 190,
    tags: [
      // { value: "Nature", title: "Nature" },
      // { value: "Flora", title: "Flora" },
    ],
    caption: "",
  },
  {
    src: "/assets/img/about/_1160134.jpg",
    original: "/assets/img/about/_1160134.jpg",
    width: 380,
    height: 334,
    caption: "",
  },
  {
    src: "/assets/img/about/_DSC9570.jpg",
    original: "/assets/img/about/_DSC9570.jpg",
    width: 320,
    height: 212,
    caption: "",
  },
  {
    src: "/assets/img/about/_DSC9467.jpg",
    original: "/assets/img/about/_DSC9467.jpg",
    width: 320,
    height: 213,
    caption: "",
  },
  {
    src: "/assets/img/about/_DSC9493.jpg",
    original: "/assets/img/about/_DSC9493.jpg",
    width: 320,
    height: 183,
    caption: "",
  },
  {
    src: "/assets/img/about/_DSC9521.jpg",
    original: "/assets/img/about/_DSC9521.jpg",
    width: 450,
    height: 300,
    tags: [],
    caption: "",
  },
  // 2nd line
  {
    src: "/assets/img/about/_DSC9529.jpg",
    original: "/assets/img/about/_DSC9529.jpg",
    width: 420,
    height: 280,
    caption: "",
  },
  {
    src: "/assets/img/about/_DSC9532.jpg",
    original: "/assets/img/about/_DSC9532.jpg",
    width: 221,
    height: 300,
    tags: [],
    caption: "",
  },
  {
    src: "/assets/img/about/_DSC9546.jpg",
    original: "/assets/img/about/_DSC9546.jpg",
    width: 340,
    height: 213,
    caption: "",
  },
  {
    src: "/assets/img/about/_DSC9553.jpg",
    original: "/assets/img/about/_DSC9553.jpg",
    alt: "Big Ben - London",
    width: 300,
    height: 450,
    caption: "",
  },
  {
    src: "/assets/img/about/_DSC9555.jpg",
    original: "/assets/img/about/_DSC9555.jpg",
    alt: "Red Zone - Paris",
    width: 342,
    height: 200,
    tags: [],
    caption: "",
  }
];
